import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Alert } from 'antd';

import { Helmet } from "react-helmet";
import data from "../../assets/data/meta.json"

import * as actions from '../../store/actions/index';
import classes from './DepartmentsTree.module.scss';

import Spinner from '../UI/Spinner/Spinner'
import DepartmentsTreeNode from './DepartmentsTreeNode/DepartmentsTreeNode';
import {
    searchTree,
    filterTree,
    checkCyrillicLetters,
    getIdForScroll,
    getAllDepartmentIds
} from '../../services/generalService'
import CustomInput from '../UI/CustomInput/CustomInput';
import EmployeesTable from "../Employees/EmployeesTable/EmployeesTable";

const isForMobile = window.innerWidth < 801;

class DepartmentsTree extends Component {
    state = {
        initialDepartments: [],
        departmentsJSX: [],
        departmentTreeSearch: '',
        departments: [],
        selectedDepartmentId: null,
        idDepartmentForScroll: null,
        commonMatchingEmployeeCount: 0,
        commonMatchingDepartmentCount: 0,
    }

    myRef = React.createRef()

    componentDidMount() {
        this.props.onGetDepartments()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.loadingDepartmentsTree === true && this.props.loadingDepartmentsTree === false) {
            let departments
            let idForScroll
            if (this.props.match.params.id) {
                departments = this.props.departments.slice()
                idForScroll = getIdForScroll(departments, parseInt(this.props.match.params.id))
            } else {
                departments = [...this.props.departments]
            }

            let desktopSelectedDepartmentId
            let mobileSelectedDepartmentId
            if (this.props.match.params.id) {
                let departmentId = parseInt(this.props.match.params.id)
                let allDepartmentsIds = getAllDepartmentIds(departments)
                if (!allDepartmentsIds.includes(departmentId)) {
                    departmentId = departments[0].data.id
                    this.setDepartmentUrl(departmentId)
                }
                desktopSelectedDepartmentId = departmentId
                mobileSelectedDepartmentId = departmentId
            } else if (departments.length !== 0) {
                desktopSelectedDepartmentId = departments[0].data.id
                mobileSelectedDepartmentId = null
            }

            this.setState((state) => {
                return {
                    ...state,
                    departments: departments,
                    initialDepartments: [...this.props.departments],
                    idDepartmentForScroll: idForScroll,
                    selectedDepartmentId: isForMobile ? mobileSelectedDepartmentId : desktopSelectedDepartmentId,
                    commonMatchingEmployeeCount: 0,
                    commonMatchingDepartmentCount: 0
                };
            }, () => {
                this.setTreeNodes(this.state.departments)
            })
        }

        if ((prevProps.loadingDepartmentsTree === this.props.loadingDepartmentsTree) && (prevProps.departments !== this.props.departments)) {
            this.setState((state) => {
                return {
                    ...state,
                    departments: [...this.props.departments],
                    departmentsJSX: [],
                    commonMatchingEmployeeCount: 0,
                    commonMatchingDepartmentCount: 0,
                };
            }, () => {
                this.setTreeNodes(this.state.departments)
            })
        }

        if (this.myRef.current && prevState.idDepartmentForScroll === this.state.idDepartmentForScroll) {
            this.executeScroll()
        }
    }

    setDepartmentUrl = (departmentId) => {
        this.props.history.replace({
            pathname: `/departments/${departmentId}`
        })
    }

    executeScroll = () => {
        this.setState(state => {
            return {...state, idDepartmentForScroll: null}
        })
        const elemToScrollTo = this.myRef.current
        this.myRef.current = null
        if (!!elemToScrollTo) {
            elemToScrollTo.scrollIntoView({behavior: 'smooth', block: 'start'})
        }
    }

    listStateHandler = (el) => {
        let tmp = [...this.state.departments]
        searchTree(tmp, el.data.id)
        this.props.onSetDepartmentsTree(tmp)
    }

    treeFilter = (e) => {
        this.setState((state) => {
            let matchingResult = filterTree(this.state.initialDepartments, checkCyrillicLetters(e.target.value))
            if (matchingResult[1] && !isForMobile) this.setDepartmentUrl(matchingResult[1])
            return {
                ...state,
                departmentsJSX: [],
                departmentTreeSearch: checkCyrillicLetters(e.target.value),
                departments: [...matchingResult[0]],
                selectedDepartmentId: matchingResult[1] && !isForMobile ? matchingResult[1] : this.state.selectedDepartmentId,
                commonMatchingEmployeeCount: 0,
                commonMatchingDepartmentCount: 0
            };
        }, () => {
            let tmp = [...this.state.departments]

            if (this.state.departmentTreeSearch === '') {
                this.props.onSetDepartmentsTree([...this.state.initialDepartments])
                return this.setTreeNodes([...this.state.initialDepartments])
            } else
                return this.setTreeNodes(tmp)
        })
    }

    setSelectedDepartment = (departmentId, isMatchingEmployee) => {
        if (departmentId) {
            this.setDepartmentUrl(departmentId)
        }
        if (!isForMobile) this.props.onSetDepartmentsTree(this.state.departments)

        this.setState(state => {
            return {...state, selectedDepartmentId: departmentId, departmentTreeSearch: (isMatchingEmployee && isForMobile) || (!isForMobile) ? this.state.departmentTreeSearch : ''}
        }, () => {
            if (isForMobile) {
                let employeeContainerDomNode = document.getElementById('employeeContainer')
                if (!!employeeContainerDomNode) {
                    employeeContainerDomNode.scrollIntoView({behavior: 'smooth', block: 'start'})
                }
            }
        })
    }

    setIdForScroll = (idForScroll) => {
        let departments = this.props.departments.slice()
        idForScroll = getIdForScroll(departments, parseInt(this.props.match.params.id))
        this.props.history.replace({
            pathname: `/departments`
        })
        this.myRef.current = null
        this.setState(state => {
            return {...state, idDepartmentForScroll: idForScroll, selectedDepartmentId: null, departmentTreeSearch: ''}
        })
        this.props.onSetDepartmentsTree(departments)
    }

    setTreeNodes = (array) => {
        for (const element of array) {
            let level = element.data.code.split(".").length - 1
            let isElementForScroll = this.state.idDepartmentForScroll && this.state.idDepartmentForScroll === element.data.id

            let matchingEmployeeCountTmp = 0
            element.data.employees.forEach(emp => {
                if (this.state.departmentTreeSearch !== ''
                    && (emp.fio.toUpperCase().includes(this.state.departmentTreeSearch.toUpperCase())
                        || emp.phoneNumbers?.some(phoneNumber => phoneNumber.includes(this.state.departmentTreeSearch.toUpperCase())))
                ) matchingEmployeeCountTmp += 1
            })
            let isMatchingDepartment = false
            if (this.state.departmentTreeSearch !== '' && element.data.name.toUpperCase().includes(this.state.departmentTreeSearch.toUpperCase())) {
                isMatchingDepartment = true
            }
            if (this.state.departmentTreeSearch !== '' && element.data.abbrev.toUpperCase().includes(this.state.departmentTreeSearch.toUpperCase())) {
                isMatchingDepartment = true
            }

            if (element.children) {
                this.setState(prevState => {
                    return {
                        commonMatchingEmployeeCount: matchingEmployeeCountTmp + prevState.commonMatchingEmployeeCount,
                        commonMatchingDepartmentCount: isMatchingDepartment ? prevState.commonMatchingDepartmentCount += 1 : prevState.commonMatchingDepartmentCount,
                        departmentsJSX: [...prevState.departmentsJSX, <div
                            ref={isElementForScroll ? this.myRef : null}
                            className={classes.nodeContainer} key={element.data.id}>
                            {(!element.isExpanded)
                                ? <div className={`${classes.listToggleExpand} DepartmentsTree_listToggleExpand_color`}
                                       onClick={() => this.listStateHandler(element)}>+</div>
                                : <div
                                    className={`${classes.listToggleCollapse} DepartmentsTree_listToggleCollapse_color`}
                                    onClick={() => this.listStateHandler(element)}>-</div>}
                            <DepartmentsTreeNode isExpanded={element.isExpanded}
                                                 data={element.data}
                                                 level={level}
                                                 searchMatch={this.state.departmentTreeSearch}
                                                 selectedDepartmentId={this.state.selectedDepartmentId}
                                                 matchingEmployeeCount={matchingEmployeeCountTmp}
                                                 setSelectedDepartment={this.setSelectedDepartment}/>
                        </div>]
                    }
                })
                if (element.isExpanded) {
                    this.setTreeNodes(element.children)
                }
            } else {
                this.setState(prevState => {
                    return {
                        commonMatchingEmployeeCount: matchingEmployeeCountTmp + prevState.commonMatchingEmployeeCount,
                        commonMatchingDepartmentCount: isMatchingDepartment ? prevState.commonMatchingDepartmentCount += 1 : prevState.commonMatchingDepartmentCount,
                        departmentsJSX: [...prevState.departmentsJSX, <div
                            ref={isElementForScroll ? this.myRef : null} className={classes.nodeContainer}
                            key={element.data.id}>
                            <DepartmentsTreeNode data={element.data}
                                                 level={level}
                                                 searchMatch={this.state.departmentTreeSearch}
                                                 selectedDepartmentId={this.state.selectedDepartmentId}
                                                 matchingEmployeeCount={matchingEmployeeCountTmp}
                                                 setSelectedDepartment={this.setSelectedDepartment}/>
                        </div>]
                    }
                })
            }
        }
    }

    clearInput = () => {
        this.setState((state) => {
            return {
                ...state,
                departmentTreeSearch: '',
                commonMatchingEmployeeCount: 0,
                commonMatchingDepartmentCount: 0
            };
        }, () => {
            this.props.onSetDepartmentsTree([...this.state.initialDepartments])
            this.setTreeNodes([...this.state.initialDepartments])
        })
    }

    render() {
        return (
            <React.Fragment>
                <Helmet>
                    <title>{data[6].title}</title>
                    <meta name="description" content={data[6].description} />
                </Helmet>
                {(!isForMobile || (isForMobile && !this.state.selectedDepartmentId))
                    && <div className={`${classes.title} DepartmentsTree_title_color`}>Основные подразделения
                    БГУИР
                </div>}
                <div className={classes.container}>
                    {(!isForMobile || (isForMobile && !this.props.match.params.id))
                        && <div className={classes.departmentsContainer}>
                            <div style={{textAlign: 'right'}}>
                                <CustomInput type="text"
                                             placeholder="Поиск..."
                                             value={this.state.departmentTreeSearch}
                                             handler={(e) => this.treeFilter(e)}
                                             clearInput={() => this.clearInput()}
                                             inputStyles={{width: '90%'}}/>
                            </div>
                            <div className={classes.searchInformation}>
                                Найдено{this.state.commonMatchingDepartmentCount || this.state.commonMatchingEmployeeCount ? ': ' : '...'}
                                {this.state.commonMatchingDepartmentCount ? `${this.state.commonMatchingDepartmentCount} подразд.` : ''}
                                {this.state.commonMatchingDepartmentCount && this.state.commonMatchingEmployeeCount ? ', ' : ''}
                                {this.state.commonMatchingEmployeeCount ? `${this.state.commonMatchingEmployeeCount} сотр.` : ''}
                            </div>
                            {
                                (this.props.loadingDepartmentsTree && this.state.departmentsJSX.length === 0)
                                    ? <Spinner/>
                                    : (this.state.departmentTreeSearch !== '' && this.state.departmentsJSX.length === 0) ?
                                        <div className={classes.alertHolder}>
                                            <Alert message="По данному запросу ничего не найдено."
                                                   className='AlertInfo'/>
                                        </div> : this.state.departmentsJSX
                            }
                        </div>}
                    {this.state.selectedDepartmentId
                        && <div className={classes.employeeContainer} id={'employeeContainer'}>
                            <EmployeesTable selectedDepartmentId={this.state.selectedDepartmentId}
                                            setIdForScroll={this.setIdForScroll}
                                            searchMatch={this.state.departmentTreeSearch}/>
                        </div>}
                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        departments: state.departments.departments,
        loadingDepartmentsTree: state.departments.loadingDepartmentsTree
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onGetDepartments: () => dispatch(actions.getDepartmentsTree()),
        onSetDepartmentsTree: (tree) => dispatch(actions.setDepartmentsTree(tree)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DepartmentsTree);